import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'CommonPDPRegular',
        path: () => path.join(__dirname, './Regular'),
        resolve: () => require.resolveWeak('./Regular'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "CommonPDPRegular" */ './Regular')]).then(
                (proms) => proms[0]
            ),
    })
);
